import { useEffect } from "react";
import { refreshManager } from "./refreshManager";

export const useAuthBootstrap = () => {
  useEffect(() => {
    // فقط warm-up (اختیاری)
    // هیچ refresh واقعی اینجا انجام نمی‌شود
    refreshManager.reset();
  }, []);
};
